'use client'
import {
  SEO_QUERY
} from "./chunk-J54FE6N4.mjs";
import {
  PAGE_SECTION_QUERY
} from "./chunk-BQV6F2AE.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  minifyGqlQuery
} from "./chunk-UBYW5IHO.mjs";
import {
  __async,
  __objRest,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/page/listing.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var PAGE_QUERY = gql`
  query getPage($lang: String, $limit: Int, $skip: Int, $where: PageFilter) {
    pageCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
      items {
        id
        title
        subtitle
        slug
        logo {${IMAGE_QUERY}}
        background {${IMAGE_QUERY}}
        seo {${SEO_QUERY}}
        sectionsCollection(limit: 25) {
          items {
            ${PAGE_SECTION_QUERY}
          }
        }
      }
    }
  }
  `;
var getPage = (_a) => __async(void 0, null, function* () {
  var _b = _a, { lang = "en" } = _b, props = __objRest(_b, ["lang"]);
  try {
    const res = yield gqlClient.request(minifyGqlQuery(PAGE_QUERY), __spreadValues({
      lang
    }, props));
    return res.pageCollection.items[0] || null;
  } catch (error) {
    throw new Exception({ error, name: "getPageException" });
  }
});
var usePage = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["page", props],
    queryFn: () => getPage(props)
  }, options));
};
var getTotalPages = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
        query getTotalPages($lang: String, $where: PageFilter) {
          pageCollection(locale: $lang, where: $where) {
            total
          }
        }
      `,
      __spreadValues({}, props)
    );
    return res.pageCollection.total;
  } catch (error) {
    throw new Exception({ error, name: "getTotalPagesException" });
  }
});

export {
  usePage,
  getTotalPages
};
//# sourceMappingURL=chunk-4ZOXI3NM.mjs.map